<mat-toolbar>
  <button id="btn-menu" mat-icon-button (click)="sidenav.toggle()">
    <span class="material-icons"> menu </span>
  </button>

  <div id="titleName">
    <h2>Mi cuenta</h2>
    <p>¡Hola! {{firebaseAuthService.publicUser.displayName}}</p>
  </div>
</mat-toolbar>

<mat-drawer-container class="example-container" [hasBackdrop]="diviceXs || diviceSm">

  <mat-drawer [mode]="!diviceXs && !diviceSm ? 'side' : 'over'" [opened]="!diviceXs && !diviceSm" #sidenav>
    <app-slider-menu></app-slider-menu>
  </mat-drawer>

  <mat-drawer-content>

    <div id="purchases">

      <h1>¡Aquí te ayudamos!</h1>

      <h4>Necesitas ayuda con: </h4>
      <section>

        <mat-tab-group>
          <mat-tab label="El pago">
            <h3>¿Cómo prefieres contactarnos?</h3>

            <div id="options">
              <div>
                <span class="material-icons-outlined">email</span>
                <p>
                  <span>Envíanos tu consulta</span>
                  <span>Te responderemos por e-mail.</span>
                </p>
              </div>

              <div>
                <span class="material-icons-outlined">chat_bubble_outline</span>
                <p>
                  <span>Chatea con nosotros</span>
                  <span>Te atenderemos en menos de 2 minutos.</span>
                </p>
              </div>

              <div>
                <span class="material-icons-outlined">chat_bubble_outline</span>
                <p>
                  <span>Chatea con nosotros</span>
                  <span>Te atenderemos en menos de 2 minutos.</span>
                </p>
              </div>
            </div>

            <!-- <form>
              <mat-form-field appearance="fill">
                <mat-label>Seleccione el problema</mat-label>
                <mat-select>
                  <mat-option *ngFor="let problem of typesOfProblemsWithPayment" [value]="problem.id">
                    {{problem.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


            </form> -->
          </mat-tab>
          <mat-tab label="El producto"> Producto </mat-tab>
        </mat-tab-group>

      </section>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
